export default __webpack_public_path__ + "static/media/loader.f0d18f79.svg";